import * as Yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

const materialSchema = {
  material: Yup.object().nullable().required('Material is required'),
  quantity: Yup.number()
    .typeError('Quantity is required')
    .positive('Value must be a positive number')
    .moreThan(0, 'Value must be greater than zero')
    .required('Quantity is required.'),
}

const validationSchema = Yup.object().shape({
  from: Yup.object().shape({
    ...materialSchema,
  }),
  to: Yup.array().of(
    Yup.object().shape({
      ...materialSchema,
    }),
  ),
  effectiveDate: Yup.string().nullable().required('Effective Date is required.'),
})

export const formOptions = {
  mode: 'onTouched',
  resolver: yupResolver(validationSchema),
  validationSchema,
}

export default validationSchema
